export default {"src":"/_next/static/media/arrow-down-tray.330e4281.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};